import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';

import { enquiryListDataAtom, enquiryListStatusAtom } from './enquiry.atom';

export const enquiryListHookUrl = () => {
  return `admin/enquiry/?${queryString({
    options: {
      sort: { createdAt: -1 },
    },
    populate: [
      { path: 'user' },
      {
        path: 'image',
      },
    ],
  })}`;
};

export const useEnquiryListhook = () => {
  const { isAdmin } = useAuth();
  useRecoilQuery(
    enquiryListStatusAtom,
    enquiryListDataAtom,
    enquiryListHookUrl(),
    fetcher,
    !isAdmin(),
  );
};

//* 내 문의 내역 — 소비자는 myEnquiries.hook(useMyEnquiries). 관리자는 /admin 전체 목록이 내려온다
export const userEnquiryListHookUrl = (role: string) => {
  return `/${role}/enquiry/?${queryString({
    options: {
      sort: { createdAt: -1 },
    },
    populate: [
      {
        path: 'image',
      },
    ],
  })}`;
};
